
import HelpfulLinkIndex from '../components/helpful_links/HelpfulLinkIndex.vue';
import Vue from 'vue';

Vue.component('helpful-link-index', HelpfulLinkIndex);

export default Vue.extend({});
